import { render, staticRenderFns } from "./addUpdHwzr.vue?vue&type=template&id=05d54939&scoped=true"
import script from "./addUpdHwzr.vue?vue&type=script&lang=js"
export * from "./addUpdHwzr.vue?vue&type=script&lang=js"
import style0 from "./addUpdHwzr.vue?vue&type=style&index=0&id=05d54939&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d54939",
  null
  
)

export default component.exports